// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty_state {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.empty_state i {
  margin: auto;
  margin-bottom: 0px;
  font-size: 90px;
  color: #ccc;
}
.empty_state h3 {
  margin: 8px 0px;
  text-align: center;
  font-weight: normal;
}
.empty_state p {
  font-size: 14px;
  margin: 0px;
  color: #999;
  text-align: center;
}



.course-container {
  transition: all 1s !important;
}
.shift {
  transform: translateX(50px);
}

.user-empty-interactions {
  min-height: 300px;
  border: 1px dashed #e5eaee;
  border-radius: 10px;
}

.hide-card {
  margin: 0 !important;
  animation: drop-card 1s forwards cubic-bezier(0.54, -0.38, 0.34, 1.42);
}

@keyframes drop-card {
  99% {
    transform: translateY(-200px);
    opacity: 0;
    display: inline-block;
  }
  100% {
    transform: translateY(-200px);
    opacity: 0;
    height: 0;
    display: none;
  }
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/user-dashboard/portal/view/portal-content/portal-pages/portal-pages.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;;;AAIA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sEAAsE;AACxE;;AAEA;EACE;IACE,6BAA6B;IAC7B,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,6BAA6B;IAC7B,UAAU;IACV,SAAS;IACT,aAAa;EACf;AACF;;AAEA,gmEAAgmE","sourcesContent":[".empty_state {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.empty_state i {\n  margin: auto;\n  margin-bottom: 0px;\n  font-size: 90px;\n  color: #ccc;\n}\n.empty_state h3 {\n  margin: 8px 0px;\n  text-align: center;\n  font-weight: normal;\n}\n.empty_state p {\n  font-size: 14px;\n  margin: 0px;\n  color: #999;\n  text-align: center;\n}\n\n\n\n.course-container {\n  transition: all 1s !important;\n}\n.shift {\n  transform: translateX(50px);\n}\n\n.user-empty-interactions {\n  min-height: 300px;\n  border: 1px dashed #e5eaee;\n  border-radius: 10px;\n}\n\n.hide-card {\n  margin: 0 !important;\n  animation: drop-card 1s forwards cubic-bezier(0.54, -0.38, 0.34, 1.42);\n}\n\n@keyframes drop-card {\n  99% {\n    transform: translateY(-200px);\n    opacity: 0;\n    display: inline-block;\n  }\n  100% {\n    transform: translateY(-200px);\n    opacity: 0;\n    height: 0;\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
